import { dashboardT } from '../../../../../../lib/messages';

export function integrationNumericFieldHint(
  field: 'targetCpm' | 'bidFloor' | 'qps' | 'shareOfVoice',
  shareOfVoice: number | undefined,
) {
  if (field === 'qps') return dashboardT('integrations.hints.qps');
  if (field !== 'shareOfVoice') return undefined;
  return dashboardT(
    shareOfVoice === 0 ? 'integrations.hints.shareOfVoiceZero' : 'integrations.hints.shareOfVoice',
  );
}
